export enum UserRole {
  Teacher = 'teacher',
  Student = 'student',
}

export interface JwtClaims {
  sub: string;
  jti: string;
  role: UserRole;
  school_id?: string | number;
  class_group_id?: string | number;
  is_test_user?: boolean;
  exp?: number;
  iat?: number;
}

export interface AuthUser {
  id: number;
  role: UserRole;
  schoolId: number | null;
  classGroupId: number | null;
  jti: string;
  isTestUser: boolean;
}
